import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../Firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc, Timestamp } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { getPlatformInfo } from '../utils/platformDetection.jsx';
import { BrowserView, mobileModel, osVersion } from 'react-device-detect';
import Eyeclose from "../../images/eye-close.svg";

const SignUpForm = () => {
  const [showCreatePassword, setShowCreatePassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const platform = getPlatformInfo();

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      toast.error('Passwords do not match', { className: 'toastify-error' });
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );
      const user = userCredential.user;
      console.log(userCredential, "userCredential");

      await setDoc(doc(db, 'users', user.uid), {
        name: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        userId: user.uid,
        platform: platform,
        registered_At: Timestamp.fromDate(new Date()),
        device_os_version: osVersion,
        device_brand: BrowserView ? 'Unknown' : 'Web',
        device_model: mobileModel || 'Unknown'
      });
      toast('Registration successful!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navigate('/dashboard');

    } catch (err) {
      toast.error(err.message, { className: 'toastify-error' });
      setError(err.message);
    }
  };

  return (
    <div className="login-box">
      <div className="head-info">
        <h2 className="mb-2">User Sign-up</h2>
        <p>Please enter your credentials to create your ez1020 account!</p>
      </div>
      {error && <p className="text-danger">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="form-field">
          <label htmlFor="fullName">Full Name</label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            placeholder="John Doe"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-field">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="johndoe@squch.com"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-field">
          <label htmlFor="phone">Phone</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder="1234567890"
            value={formData.phone}
            onChange={handleChange}

          />
        </div>
        <div className="form-field">
          <label htmlFor="password">Create Password</label>
          <div className="password-input">
            <input
              type={showCreatePassword ? 'text' : 'password'}
              id="password"
              name="password"
              placeholder="password@123"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <button type="button" className="toggle-password" aria-label="Toggle password visibility" onClick={() => setShowCreatePassword((prev) => !prev)}>
              <img
                src={
                  showCreatePassword
                    ? "https://c.animaapp.com/mcuhujz63FofVH/img/vuesax-linear-eye.svg"
                    : Eyeclose
                }
                alt={showCreatePassword ? "Hide password" : "Show password"}
              />
            </button>
          </div>
        </div>
        <div className="form-field">
          <label htmlFor="confirmPassword">Confirm Password</label>
          <div className="password-input">
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              id="confirmPassword"
              name="confirmPassword"
              placeholder="password@123"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
            <button type="button" className="toggle-password" aria-label="Toggle password visibility" onClick={() => setShowConfirmPassword((prev) => !prev)}>
              <img
                src={
                  showConfirmPassword
                    ? "https://c.animaapp.com/mcuhujz63FofVH/img/vuesax-linear-eye.svg"
                    : Eyeclose
                }

                alt={showConfirmPassword ? "Hide password" : "Show password"}
              />
            </button>
          </div>
        </div>
        <div className="form-footer mt-4">
          <button type="submit" className="login-button">Sign up</button>
          <p className="register-prompt">
            Already have an account? <a href="/" className="register-link">Login Here</a>
          </p>
        </div>
      </form>
    </div>
  );
};

export default SignUpForm;